import clsx from 'clsx';
import { observer } from 'mobx-react';
import { resetModal } from '.';
import { T } from '../../../../../../../../../../../../Translations';
import Button from '../../../../../../../../../../../Form/Button';
import InviteParticipantStore from '../../Store';

export interface Props {
  store: InviteParticipantStore;
}

function ModalButton({ store }: Props) {
  return (
    <>
      <Button
        className={clsx(
          'rounded-md cursor-pointer font-semibold text-teal-600 border px-3 py-3 text-sm w-1/2',
          'text-center mt-6 mb-4 mx-auto border-teal-600',
        )}
        value="Invite More Participants"
        type="button"
        onClick={store.getLicenseInformation}
      />
      <div
        className={clsx(
          'rounded-md cursor-pointer font-semibold text-teal-600 px-3 py-2 text-sm w-1/2 text-center mb-16 mx-auto',
        )}
        onClick={() => resetModal(store)}
      >
        <T kind="Return to Collection" />
      </div>
    </>
  );
}

export default observer(ModalButton);
